import Inquiry from 'app/shared/model/Inquiry';

const Conversation = ({
    conversationId = '',
    inquiry = {},
    listingId = '',
    address = '',
    aliasEncoded = '',
} = {}) => ({
    conversationId: String(conversationId),
    inquiry: Inquiry(inquiry),
    listingId: String(listingId),
    address: String(address),
    aliasEncoded: String(aliasEncoded),
});

export default Conversation;
